import {addGlobalEventListener, appendScript, appendStyle, createElement, qs, qsa} from "../utils/domUtils";

export default function initTable (tableEl) {
    // parse columns data
    let actionExists = false;
    let orderIndex = actionExists ? 1 : 0;
    let columns = [...tableEl.tHead.rows[0].cells].map((item, index) => {
        if (item.dataset.orderDefault){
            orderIndex = index
        }
        if(item.dataset.ajaxField == 'actions'){
            actionExists = true;
            return {
                data: '',
                defaultContent: '',
            };
        }
        let columnData = {
            data: {
                _: item.dataset.ajaxField,
            },
            defaultContent: '',
        };
        if (item.dataset.sortField){
            columnData.data.sort = item.dataset.sortField
        }
        if (item.dataset.link){
            columnData.fnCreatedCell = (td, sData, oData, iRow) => {
                const a = document.createElement('a')
                a.innerText = td.innerText
                a.target = '_blank'
                a.href = decodeURI(item.dataset.link).replace('[instance-id]', oData?.invoice?.id)
                td.innerHTML = a.outerHTML
            }
        }

        if ('disableSort' in item.dataset){
            columnData.orderable = false;
            columnData.data.sort = null;
        }
        return columnData;
    });
    let $table = $(tableEl);
    let searchable = 'search' in tableEl.dataset
    const searchLabel = tableEl.dataset.search || 'חיפוש קבלה הכנס שנת מס'
    let apiMethod = tableEl.dataset.ajaxUrl;
    let createNewTitle = tableEl.dataset.createNewTitle || 'הוסף חדש'

    // display filters

    // getting fixed filter for table
    let prefilledFilters = tableEl.dataset?.prefilledFilters;
    if (prefilledFilters){
        // convert to object
        prefilledFilters = JSON.parse(prefilledFilters);
    }

    //Get Table title
    let title = tableEl.dataset.title;

    // Init buttons array
    let buttons = [];
    //push button for create link
    let createUrl = tableEl.dataset?.createUrl;

    let createModalTarget = tableEl.dataset?.bsTarget;
    if (createUrl){
        let createLink =  {
            text: feather.icons['plus'].toSvg({class: 'me-50 font-small-4'}) + createNewTitle,
            className: 'create-new btn btn-primary',
            tag: 'a',
            attr: {
                'href': createUrl
            },
            init: (dt, button, config) => {
                // for activate regular link event
                let cloneButton = button.get(0).cloneNode();
                button.replaceWith(cloneButton);
            }
        }
        buttons.push(createLink)
    }

    if (tableEl.dataset?.exportLinks){
        let exports = JSON.parse(tableEl.dataset?.exportLinks);
        let exportButtons = [];
        if (exports.length){
            exports.forEach((item) => {
                exportButtons.push({
                    text: feather.icons['file'].toSvg({class: 'font-small-4 me-50'}) + item.name,
                    tag: 'a',
                    attr: {
                        'href': item.link
                    },
                    className: 'dropdown-item',
                    init: (dt, button, config) => {},
                    action: function(e, dt, node, config) {
                        let params = dt.ajax.params();
                        let {page, orderData, search, length, ...filterParams} = params;
                        let exportUrl = new URL(item.link);
                        if(search?.length){
                            exportUrl.searchParams.append('search', search)
                        }
                        for (const filterParamsKey in filterParams) {
                            if (!filterParams[filterParamsKey]){
                                continue;
                            }
                            exportUrl.searchParams.append(filterParamsKey, filterParams[filterParamsKey])
                        }
                        window.location.href = exportUrl.href
                    }
                })
            });
            buttons.push({
                extend: 'collection',
                className: 'btn btn-outline-secondary dropdown-toggle ms-2',
                text: feather.icons['share'].toSvg({class: 'font-small-4 me-50'}) + 'ייצוא לאקסל',
                buttons: exportButtons,
                init: (api, node, config) => {
                    $(node).removeClass('btn-secondary');
                    $(node).parent().removeClass('btn-group');
                    setTimeout(() => {
                        $(node).closest('.dt-buttons').removeClass('btn-group').addClass('d-inline-flex')
                    })
                }
            })
        }
    }

    if (createModalTarget){
        let createLink =  {
            text: feather.icons['plus'].toSvg({class: 'me-50 font-small-4'}) + createNewTitle,
            className: 'create-new btn btn-primary',
            tag: 'a',
            attr: {
                'data-bs-toggle': 'modal',
                'data-bs-target': createModalTarget
            },
            init: (dt, button, config) => {
                // for activate regular link event
            }
        }
        buttons.push(createLink)
    }

    // Getting filters extra
    let filters = getFilterElements(tableEl);

    $table.on('processing.dt', function(e, settings, processing){
        let datatableContainer = e.currentTarget;
        let tableMainContainer = datatableContainer.closest('.dataTables_wrapper')
        let existsSpinner = tableMainContainer.querySelector('.spinner');
        if (processing){
            datatableContainer.classList.add('processing')
            if(!existsSpinner){
                let spinner = document.createElement('div');
                spinner.classList.add('spinner-border', 'text-primary', 'spinner')
                tableMainContainer.appendChild(spinner)
            }
        } else {
            datatableContainer.classList.remove('processing')
            existsSpinner?.remove()
        }
    })

    let actionCol = !actionExists ? {} : {
        targets: 0,
        orderable: false,
        createdCell: function(td, cellData, rowData, row, col) {
            let $table = this.DataTable();
            initEditFormEvent(td, $table)
            initDeleteEvent(td, $table)
            initCollapseEvent(td, $table)
        },
        render: (data, type, full, meta) => {
            let rowIndex = meta.row;
            let editUrl = decodeURI(meta.settings.aoColumns[0].ajaxEdit);
            let showUrl = decodeURI(meta.settings.aoColumns[0].ajaxShow);
            let deleteUrl = decodeURI(meta.settings.aoColumns[0].ajaxDelete);
            editUrl = editUrl.replace('[instance-id]', full.id)
            deleteUrl = deleteUrl.replace('[instance-id]', full.id)
            showUrl = showUrl.replace('[instance-id]', full.id)
            editUrl = editUrl.replace('[instance-index]', rowIndex)
            deleteUrl = deleteUrl.replace('[instance-index]', rowIndex)
            showUrl = showUrl.replace('[instance-index]', rowIndex)

            // edit modal form
            let editModal = false;
            if ('ajaxEditForm' in meta.settings.aoColumns[0]){
                editModal = true;
            }

            let extraButtons = getExtraActionButtons(meta.settings.aoColumns[0], full);

            let collapseButton = getCollapseButton(meta.settings.aoColumns[0], full);
            let checkboxField = meta.settings.aoColumns[0].checkbox
            let checkbox = false
            if (checkboxField && full.leftToPay > 0 && full.amount > 0){
                checkbox = document.createElement('input')
                checkbox.classList.add('form-check')
                checkbox.type = 'checkbox'
                checkbox.id = "table-checkbox"
                checkbox.name = 'values[]'
                checkbox.value = full[checkboxField]
                for (const fullKey in full) {
                    checkbox.dataset[fullKey] = full[fullKey]
                }
            }
            return (
                `<div class="d-inline-flex">
    ${showUrl != 'undefined' ? `<a href="${showUrl}" class="item-edit me-1">${feather.icons['eye'].toSvg({class: 'font-small-4'})}</a>` : ''}
    ${(full.can_update === 1 || full.can_update === undefined) && editUrl != 'undefined' ? `<a href="${editUrl}" class="item-edit${editModal ? '-modal' : ''} me-1">${feather.icons['edit'].toSvg({class: 'font-small-4'})}</a>` : ''}
    ${(full.can_delete === 1 || full.can_delete === undefined ) && deleteUrl != 'undefined' ? `<a href="${deleteUrl}" class="item-delete text-danger">${feather.icons['delete'].toSvg({class: 'font-small-4'})}</a> ${extraButtons.join('')}` : ''}
    ${collapseButton}
    ${checkbox ? checkbox.outerHTML : ''}
</div>`
            )
        }
    }

    let columnDefs = []
    if (actionExists){
        columnDefs.push(actionCol)
    }

    let table = $table.DataTable({
        'processing': true,
        'bProcessing': true,
        fnDrawCallback: (settings) => {
            tableEl.dispatchEvent(new Event('spray-dev:refresh'))
            if (settings._iDisplayLength > settings.fnRecordsDisplay()){
                $(settings.nTableWrapper).find('.dataTables_paginate').hide();
            } else {
                $(settings.nTableWrapper).find('.dataTables_paginate').show();
            }
        },
        searching: searchable,
        serverSide: true,
        columns: columns,
        iDisplayLength: 100,
        columnDefs: columnDefs,
        createdRow: function(row, data){
            if (data.leftToPay > 0){
                $(row).addClass('debt-row')
            }
        },
        order: [[orderIndex, 'asc']],
        dom: '<"card-header border-bottom p-1"<"head-label"><"dt-action-buttons text-end"B>><"card-body mt-2"><"d-flex justify-content-between filter-container align-items-center mx-0 row"<"col-sm-12 col-md-3"l><"col-sm-12 col-md-3"f>><"d-flex align-items-center mx-0 row totals"><"table-scroll"t><"d-flex justify-content-between mx-0 row"<"col-sm-12 col-md-6"i><"col-sm-12 col-md-6"p>>',
        ajax: {
            url: apiMethod,
            dataFilter: function(data){
                // Converting response data to DATATABLE format
                let response = JSON.parse(data);
                let json = {};
                if (response.totals){
                    let tableContainer = $table.DataTable().table().container();
                    qs('.totals', tableContainer).innerHTML = '';
                    response.totals.forEach((total) => {
                        if (total.value === null){
                            return;
                        }
                        let totalHolder = createElement('div', {
                            class: ['col-md-3'],
                        })
                        let totalTitle = createElement('span')
                        totalTitle.innerHTML = `<strong>${total.title}</strong>: ${total.value}`
                        totalHolder.appendChild(totalTitle);
                        qs('.totals', tableContainer).appendChild(totalHolder)
                    })
                }
                json.recordsTotal = response.total;
                json.recordsFiltered = response.total;
                json.data = response.data;
                return JSON.stringify(json);
            },
            data: (data) => {
                // Converting request data from DATATABLE to what we needs
                let request = {};
                // Calc page param
                let page = data.start/data.length + 1;
                request.page = page;

                // get column for sorting and sort type
                // sorting only by 1 field
                let orderParams = data.order[0];
                let orderingColumn = data.columns[orderParams.column]?.data;
                let orderType = orderParams.dir;

                if (orderingColumn){
                    request.orderData = {
                        field: orderingColumn.sort ?? orderingColumn._,
                        type: orderType
                    }
                }

                request.search = data.search.value;
                request.length = data.length;
                if (prefilledFilters){
                    request = {...request, ...prefilledFilters}
                }

                let extraFilters = getFilterValues(filters)
                if (extraFilters){
                    extraFilters.forEach((extraFilter) => {
                        request[extraFilter.name] = extraFilter.value
                    });
                }

                return request;
            }
        },
        buttons: buttons,
        language: {
            paginate: {
                // remove previous & next text from pagination
                previous: '&nbsp;',
                next: '&nbsp;'
            },
            search: searchLabel,
            // info: "הראה _MENU_ to _END_ of _TOTAL_ רשומות",
            info: "מראה _START_ עד _END_ מתוך _TOTAL_",
            infoEmpty: "",
            lengthMenu: "הראה _MENU_ רשומות",
            zeroRecords: 'אין תוצאות',
            emptyTable: 'אין תוצאות',
        }
    });
    // append title of table
    let tableContainer = table.table().container();
    if (title){
        $(tableContainer).find('.head-label').html(`<h4 class="card-header">${title}</h4>`);
    }

    appendFilters(filters, table);

    // Listen events for table
    tableEl.addEventListener('spraydev:refresh-table', (e) => {
        table.ajax.reload()
    })
}


const getFilterElements = (tableEl) => {
    if (!tableEl.dataset.filterBlock){
        return false;
    }
    let filterBlock = qs(tableEl.dataset.filterBlock);
    if (!filterBlock){
        return false;
    }

    let filters = qsa('[data-filter]', filterBlock);
    return filters;
}

const appendFilters = (filters, datatable) => {
    let tableContainer = qs('.filter-container', datatable.table().container());
    if (!filters){
        return;
    }

    let mainFilters = filters.slice(0, 4);
    let additionalFilters = filters.slice(4);

    mainFilters.forEach((item, index) => {
        let inputContainer = createElement('div', {
            class: ['col-md-3', 'col-sm-12'],
        });
        if (item.closest('[data-filter-container]')){
            inputContainer.appendChild(item.closest('[data-filter-container]'));
        } else {
            inputContainer.appendChild(item);
        }
        tableContainer.appendChild(inputContainer);

        if (item.tagName !== 'BUTTON'){
            if (item.classList.contains('select2')){
                // $(item).on('select2:select', (e) => {
                //     datatable.ajax.reload();
                // })
                $(item).on('change', (e) => {
                    datatable.ajax.reload();
                })
                return;
            }
            item.addEventListener('change', () => {
                datatable.ajax.reload();
                // datatable.table().ajax.reload()
            })
        }
    })


    // Adding additional filters block
    if (!additionalFilters.length)
        return;

    let additionalContainer = createElement('div', {
        class: ['col-md-12']
    })

    let buttonHolder = createElement('div', {
        class: ['d-flex', 'justify-content-center']
    })

    let tableId = datatable.table().node().id;
    let filtersId = `more-filters-${tableId}`;

    let moreFiltersButton = createElement('button', {
        class: ['accordion-button', 'filters-button', 'd-flex', 'justify-content-center'],
        dataset: {
            'bsToggle': 'collapse',
            'bsTarget': `#${filtersId}`
        }
    })

    let buttonText = createElement('span', {
        text: 'סינונים נוספים'
    })
    moreFiltersButton.append(buttonText);
    buttonHolder.append(moreFiltersButton);
    additionalContainer.append(buttonHolder)

    let filtersContainer = createElement('div', {
        class: ['row', 'accordion', 'accordion-margin', 'mt-2', 'collapse'],
        id: filtersId,
    })

    additionalFilters.forEach((item, index) => {
        let inputContainer = createElement('div', {
            class: ['col-md-3', 'col-6'],
        });
        if (item.closest('[data-filter-container]')){
            inputContainer.appendChild(item.closest('[data-filter-container]'));
        } else {
            inputContainer.appendChild(item);
        }
        filtersContainer.appendChild(inputContainer);

        if (item.tagName !== 'BUTTON'){
            if (item.classList.contains('select2')){
                // $(item).on('select2:select', (e) => {
                //     datatable.ajax.reload();
                // })
                $(item).on('change', (e) => {
                    datatable.ajax.reload();
                })
                return;
            }
            item.addEventListener('change', () => {
                datatable.ajax.reload();
                // datatable.table().ajax.reload()
            })
        }
    })

    additionalContainer.appendChild(filtersContainer);

    tableContainer.appendChild(additionalContainer)
}

const getFilterValues = (filters) => {
    if (!filters){
        return null;
    }
    return filters.map((item) => {
        return {
            name: item.name,
            value: $(item).val(),
        }
    });
}

const initDeleteEvent = (td, dataTable) => {
    if (!qs('.item-delete', td)){
        return;
    }
    td.querySelector('.item-delete').addEventListener('click', (e) => {
        e.preventDefault();
        axios({
            method: 'DELETE',
            url: e.currentTarget.href,
        })
            .then(() => {
                dataTable.ajax.reload();
            })
    })
}

const initEditFormEvent = (td, dataTable) => {
    if (!qs('.item-edit-modal', td)){
        return;
    }
    qs('.item-edit-modal', td).addEventListener('click', (e) => {
        e.preventDefault();
        let tableId = dataTable.table().node().id;
        let hashString = generateHash(e.currentTarget.href);
        let modalHolder = undefined;
        if (!qs(`#edit-${tableId}`, document.body)){
            modalHolder = createElement('div', {
                id: `edit-${tableId}`
            })
        } else {
            modalHolder = qs(`#edit-${tableId}`, document.body);
            modalHolder.innerHTML = '';
        }

        axios.get(e.currentTarget.href)
            .then(response => {
                let data = response.data;
                modalHolder.innerHTML = data.data
                document.body.appendChild(modalHolder);
                initSelect2InModal(modalHolder.firstChild);
                $(modalHolder.firstChild).modal('show');
                // handle submit event
                let editForm = qs('form', modalHolder);
                initUpdateEvent(editForm, dataTable, modalHolder.firstChild)
            })
    })
}

const initUpdateEvent = (form, table, modal) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        let formData = new FormData(form);
        axios.post(form.action, formData)
            .then((response) => {
                $(modal).modal('hide');
                table.ajax.reload();
            })
    })
}

const initCollapseEvent = (td, datatable) => {
    if (!qs('.item-collapse', td)){
        return;
    }

    let collapseButton = qs('.item-collapse', td);

    collapseButton.addEventListener('click', (e) => {
        if (collapseButton.classList.contains('collapsed')){
            let currentRow = datatable.row($(td).closest('tr'));
            currentRow.child.hide()
            collapseButton.innerHTML = feather.icons['plus-circle'].toSvg({class: 'font-small-4'});
            collapseButton.classList.remove('collapsed');
            return;
        }
        // console.log(datatable.columns().header())
        let requestDataUrl = collapseButton.dataset.ajaxRoute;
        axios.get(requestDataUrl)
            .then(response => {
                let responseData = response.data;
                if (!responseData.success){
                    return;
                }
                let collapsedData = responseData.data.rows
                let collapsedHeaderData = responseData.data.headers
                let collapsedTable = buildCollapsedTable(collapsedHeaderData, collapsedData)
                let currentRow = datatable.row($(td).closest('tr'));
                currentRow.child(collapsedTable.outerHTML).show()
                collapseButton.innerHTML = feather.icons['minus-circle'].toSvg({class: 'font-small-4'});
                collapseButton.classList.add('collapsed');
            })
    })
}

const buildCollapsedTable = (headers, data) => {
    let table = createElement('table', {
        class: ['table', 'table-info'],
    })
    let thead = createElement('thead')
    let theadRow = createElement('tr')
    for (const headersKey in headers) {
        let title = headers[headersKey]
        let th = createElement('th', {
            text: title
        });
        theadRow.appendChild(th)
    }
    thead.append(theadRow)
    table.prepend(thead)
    data.forEach((row) => {
        let tr = createElement('tr')
        for (const headersKey in headers) {
            let title = headers[headersKey]
            let name = headersKey
            let cellValue = row
            name.split('.').forEach((item) => {
                cellValue = cellValue[item]
            })
            let td = createElement('td', {
                text: cellValue
            });
            tr.appendChild(td)
        }
        table.appendChild(tr);
    })

    return table;
}

const generateHash = (string) => {
    let hash = 0;
    if (string.length === 0) return hash;
    for (let i = 0; i < string.length; i++) {
        let char = string.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash
    }
    return hash
}

const initSelect2InModal = (modal) => {
    // init select2
    if (qs('.select2', modal)){
        if ($().select2){
            // init default select2 selectors
            let select2Elements = qsa('.select2')
            select2Elements.forEach(item => {
                let options = {};
                if (item.multiple){
                    options.closeOnSelect = false
                }
                if ('taggable' in item.dataset){
                    options.tags = true
                }

                // change parent if in modal
                if (item.closest('.modal')){
                    options.dropdownParent = $(item.closest('.modal'));
                }
                $(item).select2(options);
            })
        } else {
            appendScript('/vendors/js/forms/select/select2.full.min.js').then(() => {
                appendStyle('/vendors/css/forms/select/select2.min.css')
                // init default select2 selectors
                let select2Elements = qsa('.select2')
                select2Elements.forEach(item => {
                    let options = {};
                    if (item.multiple){
                        options.closeOnSelect = false
                    }
                    if ('taggable' in item.dataset){
                        options.tags = true
                    }

                    // change parent if in modal
                    if (item.closest('.modal')){
                        options.dropdownParent = $(item.closest('.modal'));
                    }
                    $(item).select2(options);
                })
            })
        }
    }
}

const getExtraActionButtons = (actionCellDataset, row) => {
    let {ajaxShow, ajaxDelete, ajaxEdit, ajaxField, ...restActions} = actionCellDataset;
    let actionButtons = [];
    for (const restActionsKey in restActions) {
        if (!restActions[restActionsKey]?.action){
            continue;
        }
        let actionData = restActions[restActionsKey];
        let condition = actionData.condition;
        let compareSign = condition[1];
        let conditionReturn;
        let compareValue0 = typeof condition[0] == 'string' ? row[condition[0]] : condition[0];
        let compareValue1 = typeof condition[2] == 'string' ? row[condition[2]] : condition[2];
        switch (compareSign) {
            case '<':
                conditionReturn = compareValue0 < compareValue1;
                break;
            case '>':
                conditionReturn = compareValue0 > compareValue1;
                break;
            case '=':
                conditionReturn = compareValue0 === compareValue1;
                break;
            case '<=':
                conditionReturn = compareValue0 <= compareValue1;
                break;
            case '>=':
                conditionReturn = compareValue0 >= compareValue1;
                break;
        }
        if (conditionReturn){
            actionButtons.push(`<a onclick="window['${actionData.action}'](${row.id})" href="javascript:void(0)" class="item-edit ms-1">${feather.icons[actionData.icon].toSvg({class: 'font-small-4'})}</a>`)
        }
    }

    return actionButtons
}

const getCollapseButton = (actionCellDataset, row) => {
    let {ajaxCollapse} = actionCellDataset;
    if(typeof ajaxCollapse === 'string'){
        ajaxCollapse = JSON.parse(ajaxCollapse)
    }
    if (!ajaxCollapse){
        return '';
    }

    let ajaxRoute = decodeURI(ajaxCollapse.route).replaceAll('[replace-me]', row[ajaxCollapse.field])

    let collapseButton = createElement('a', {
        class: ['item-collapse', 'ms-1'],
        href: 'javascript:void(0)',
        dataset: {
            ajaxRoute
        }
    });
    collapseButton.innerHTML = feather.icons['plus-circle'].toSvg({class: 'font-small-4'})
    return collapseButton.outerHTML;
}
